import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './assay.reducer';

export const AssayDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const assayEntity = useAppSelector(state => state.assay.entity);

  return (
    <Row>
      <Col md="8">
        <h2 data-cy="assayDetailsHeading">
          <Translate contentKey="coconApp.assay.detail.title">Assay</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{assayEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="coconApp.assay.name">Name</Translate>
            </span>
          </dt>
          <dd>{assayEntity.name}</dd>
          <dt>
            <span id="datasets">
              <Translate contentKey="coconApp.dataset.home.title">Datasets</Translate>
            </span>
          </dt>
          <dd>
            {assayEntity.datasets
              ?.map(dataset => dataset.id)
              .sort()
              .map(datasetId => (
                <>
                  <Link to={`/dataset/${datasetId}`} key={datasetId}>
                    {datasetId}
                  </Link>
                  &nbsp;
                </>
              ))}
          </dd>
        </dl>
        <Button tag={Link} to="/assay" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/assay/${assayEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AssayDetail;
